<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Impressoras B2338, B2442, M1242, MS321, MS421">
     Impressoras B2338, B2442, M1242, MS321, MS421
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_pt" title="Informa&ccedil;&otilde;es sobre seguran&ccedil;a">
     Informa&ccedil;&otilde;es sobre seguran&ccedil;a
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Conven&ccedil;&otilde;es">
      Conven&ccedil;&otilde;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Declara&ccedil;&otilde;es de produtos">
      Declara&ccedil;&otilde;es de produtos
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_pt" title="Aprender sobre a impressora">
     Aprender sobre a impressora
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_pt" title="Localiza&ccedil;&atilde;o das informa&ccedil;&otilde;es sobre a impressora">
      Localiza&ccedil;&atilde;o das informa&ccedil;&otilde;es sobre a impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_pt" title="Selecionando um local para a impressora">
      Selecionando um local para a impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_pt" title="Configura&ccedil;&otilde;es da impressora">
      Configura&ccedil;&otilde;es da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_pt" title="Conectando cabos">
      Conectando cabos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_pt" title="Usando o painel de controle">
      Usando o painel de controle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_pt" title="Aprender sobre o status do bot&atilde;o liga/desliga e da luz indicadora">
      Aprender sobre o status do bot&atilde;o liga/desliga e da luz indicadora
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_pt" title="Carregamento de papel e m&iacute;dia especial">
     Carregamento de papel e m&iacute;dia especial
    </a>
   </p>
   <div id="divd0e736">
    <p class="toc-2-style">
     <a href="setting-size-and-type-of-specialty-media-topic.html#setting-size-and-type-of-specialty-media_pt" title="definindo o tamanho e o tipo da m&iacute;dia especial">
      definindo o tamanho e o tipo da m&iacute;dia especial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-h1-topic.html#configuring-universal-paper-settings-h1_pt" title="definindo as defini&ccedil;&otilde;es do papel Universal">
      definindo as defini&ccedil;&otilde;es do papel Universal
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_pt" title="Carregamento de bandejas">
      Carregamento de bandejas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_pt" title="Carregamento do alimentador multiuso">
      Carregamento do alimentador multiuso
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_pt" title="Vincula&ccedil;&atilde;o de bandejas">
      Vincula&ccedil;&atilde;o de bandejas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_pt" title="Suporte de papel">
     Suporte de papel
    </a>
   </p>
   <div id="divd0e929">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-gsm-topic.html#supported-paper-sizes-gsm_pt" title="Tamanhos de papel suportados">
      Tamanhos de papel suportados
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-gold-topic.html#supported-paper-types-gold_pt" title="Tipos de papel suportados">
      Tipos de papel suportados
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-gsm-topic.html#supported-paper-weights-gsm_pt" title="Gramaturas de papel compat&iacute;veis">
      Gramaturas de papel compat&iacute;veis
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_pt" title="Papel inaceit&aacute;vel">
      Papel inaceit&aacute;vel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_pt" title="Uso de papel reciclado">
      Uso de papel reciclado
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_pt" title="Impress&atilde;o">
     Impress&atilde;o
    </a>
   </p>
   <div id="divd0e1536">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_pt" title="Impress&atilde;o de um computador">
      Impress&atilde;o de um computador
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1562" title="Impress&atilde;o a partir de um dispositivo m&oacute;vel">
      Impress&atilde;o a partir de um dispositivo m&oacute;vel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_pt" title="Imprimindo uma lista de amostras de fontes">
      Imprimindo uma lista de amostras de fontes
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_pt" title="Compreendendo os menus da impressora">
     Compreendendo os menus da impressora
    </a>
   </p>
   <div id="divd0e1706">
    <p class="toc-2-style">
     <a href="menus-map-topic.html#menus-map_pt" title="Mapa de menus">
      Mapa de menus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e1885" title="Dispositivo">
      Dispositivo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e2851" title="Imprimir">
      Imprimir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e3828" title="Papel">
      Papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e4065" title="Rede/portas">
      Rede/portas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e5545" title="Relat&oacute;rios">
      Relat&oacute;rios
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-group.html#d0e5674" title="Solu&ccedil;&atilde;o de problemas">
      Solu&ccedil;&atilde;o de problemas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_pt" title="Impress&atilde;o da P&aacute;gina de configura&ccedil;&otilde;es de menu">
      Impress&atilde;o da P&aacute;gina de configura&ccedil;&otilde;es de menu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_pt" title="Protegendo a impressora">
     Protegendo a impressora
    </a>
   </p>
   <div id="divd0e5728">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_pt" title="Localiza&ccedil;&atilde;o do slot de seguran&ccedil;a">
      Localiza&ccedil;&atilde;o do slot de seguran&ccedil;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_pt" title="Apagando a mem&oacute;ria da impressora">
      Apagando a mem&oacute;ria da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_pt" title="Restaurando as defini&ccedil;&otilde;es padr&atilde;o de f&aacute;brica">
      Restaurando as defini&ccedil;&otilde;es padr&atilde;o de f&aacute;brica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_pt" title="Declara&ccedil;&atilde;o de volatilidade">
      Declara&ccedil;&atilde;o de volatilidade
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_pt" title="Manuten&ccedil;&atilde;o da impressora">
     Manuten&ccedil;&atilde;o da impressora
    </a>
   </p>
   <div id="divd0e5900">
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e5905" title="Rede">
      Rede
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_pt" title="Limpeza da impressora">
      Limpeza da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies.html#ordering-supplies_pt" title="Solicitando pe&ccedil;as e suprimentos">
      Solicitando pe&ccedil;as e suprimentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e6526" title="Trocando pe&ccedil;as e suprimentos">
      Trocando pe&ccedil;as e suprimentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer.html#moving-the-printer_pt" title="Transportando a impressora">
      Transportando a impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e6725" title="Economizando energia e papel">
      Economizando energia e papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#d0e6873" title="Reciclagem">
      Reciclagem
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_pt" title="Limpando atolamentos">
     Limpando atolamentos
    </a>
   </p>
   <div id="divd0e6927">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_pt" title="Para evitar atolamentos">
      Para evitar atolamentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_pt" title="Identificando os locais dos atolamentos">
      Identificando os locais dos atolamentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_pt" title="Atolamento de papel na porta A">
      Atolamento de papel na porta A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_pt" title="Atolamento de papel na porta traseira">
      Atolamento de papel na porta traseira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_pt" title="Atolamento de papel na bandeja padr&atilde;o">
      Atolamento de papel na bandeja padr&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_pt" title="Atolamento de papel na unidade duplex">
      Atolamento de papel na unidade duplex
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_pt" title="Atolamento de papel nas bandejas">
      Atolamento de papel nas bandejas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_pt" title="Atolamento de papel no alimentador multiuso">
      Atolamento de papel no alimentador multiuso
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_pt" title="Solu&ccedil;&atilde;o de problemas">
     Solu&ccedil;&atilde;o de problemas
    </a>
   </p>
   <div id="divd0e7203">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e7206" title="Problemas de conex&atilde;o de rede">
      Problemas de conex&atilde;o de rede
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e7353" title="Problemas com suprimentos">
      Problemas com suprimentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e7499" title="Problemas na bandeja de papel">
      Problemas na bandeja de papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-blank-or-white-pages-topic.html#d0e7885" title="Problemas de impress&atilde;o">
      Problemas de impress&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_pt" title="Entrando em contato com o suporte ao cliente">
      Entrando em contato com o suporte ao cliente
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-and-migrating-chapter.html#upgrading-and-migrating-chapter_pt" title="Atualizando e migrando">
     Atualizando e migrando
    </a>
   </p>
   <div id="divd0e10237">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e10240" title="Hardware">
      Hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e10400" title="Software">
      Software
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e10476" title="Firmware">
      Firmware
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_pt" title="Avisos">
     Avisos
    </a>
   </p>
   <div id="divd0e10545">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10548" title="Informa&ccedil;&otilde;es sobre o produto">
      Informa&ccedil;&otilde;es sobre o produto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10565" title="Aviso de edi&ccedil;&atilde;o">
      Aviso de edi&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_pt" title="Marcas comerciais">
      Marcas comerciais
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_pt" title="Avisos de licenciamento">
      Avisos de licenciamento
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_pt" title="N&iacute;veis de emiss&atilde;o de ru&iacute;do">
      N&iacute;veis de emiss&atilde;o de ru&iacute;do
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_pt" title="Diretiva de res&iacute;duos de equipamentos el&eacute;tricos e eletr&ocirc;nicos (WEEE, Waste from Electrical and Electronic Equipment)">
      Diretiva de res&iacute;duos de equipamentos el&eacute;tricos e eletr&ocirc;nicos (WEEE, Waste from Electrical and Electronic Equipment)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10667" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_pt" title="Descarte do produto">
      Descarte do produto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10701" title="Bateria recarreg&aacute;vel de &iacute;ons de l&iacute;tio">
      Bateria recarreg&aacute;vel de &iacute;ons de l&iacute;tio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_pt" title="Norma (UE) 2023/1542">
      Norma (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_pt" title="A devolu&ccedil;&atilde;o de cartuchos Lexmark para reutiliza&ccedil;&atilde;o ou reciclagem">
      A devolu&ccedil;&atilde;o de cartuchos Lexmark para reutiliza&ccedil;&atilde;o ou reciclagem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_pt" title="Aviso de sensibilidade &agrave; est&aacute;tica">
      Aviso de sensibilidade &agrave; est&aacute;tica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_pt" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_pt" title="Informa&ccedil;&otilde;es sobre temperatura">
      Informa&ccedil;&otilde;es sobre temperatura
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_pt" title="Aviso sobre laser">
      Aviso sobre laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#notice-to-users-of-products-in-brazil_pt" title="Aviso aos usu&aacute;rios de produtos no Brasil">
      Aviso aos usu&aacute;rios de produtos no Brasil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_pt" title="Consumo de energia">
      Consumo de energia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10946" title="Avisos regulamentares para produtos sem fio">
      Avisos regulamentares para produtos sem fio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_pt" title="Aviso de componente modular">
      Aviso de componente modular
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_pt" title="Exposi&ccedil;&atilde;o &agrave; radia&ccedil;&atilde;o de radiofreq&uuml;&ecirc;ncia">
      Exposi&ccedil;&atilde;o &agrave; radia&ccedil;&atilde;o de radiofreq&uuml;&ecirc;ncia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_pt" title="Conformidade com as diretivas da Comunidade Europeia (CE)">
      Conformidade com as diretivas da Comunidade Europeia (CE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10980" title="Conformidade com as diretivas da Comunidade Europeia (CE)">
      Conformidade com as diretivas da Comunidade Europeia (CE)
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue